const reducer = (state = '', action) =>{
    switch(action.type){
        case "setConsortiumSearch": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  